// src/components/avatar/avatarTypes.ts

export interface DiceCatAvatar {
  color: string;
  hat?: string;
  face?: string;
  glasses?: string;
  rightHand?: string;
  leftHand?: string;
  body?: string;
}

// Special admin brand color - not selectable by regular users
export const ADMIN_AVATAR_COLOR = '#16a75a';

export const AVATAR_COLORS = [
  { name: 'Red', value: '#E53935' },
  { name: 'Blue', value: '#1E88E5' },
  { name: 'Lime', value: '#97fe6c' }, // Changed from 'Green' - new lime-forest color
  { name: 'Yellow', value: '#FDD835' },
  { name: 'Purple', value: '#8E24AA' },
  { name: 'Orange', value: '#FB8C00' },
  { name: 'Pink', value: '#D81B60' },
  { name: 'Teal', value: '#00897B' },
  { name: 'Brown', value: '#6D4C41' },
  { name: 'Black', value: '#424242' },
  { name: 'White', value: '#FAFAFA' },
  { name: 'Gray', value: '#757575' },
];

export const HATS = [
  { name: 'None', value: null },
  { name: 'Antlers', value: 'antlers' },
  { name: 'Crown', value: 'crown' },
  { name: 'Devil Horns', value: 'devilHorns' },
  { name: 'Flower Hat', value: 'flowerHat' },
  { name: 'Mask', value: 'mask' },
  { name: 'Santa Hat', value: 'santaHat' },
  { name: 'Tall Horns', value: 'tallHorns' },
  { name: 'Top Hat', value: 'topHat' },
  { name: 'Witch Hat', value: 'witchHat' },
  { name: 'Wizard Hat', value: 'wizardHat' },
];

export const GLASSES = [
  { name: 'None', value: null },
  { name: 'Goggles', value: 'goggles' },
  { name: 'Monocle', value: 'monocle' },
  { name: 'Reading Glasses', value: 'readingGlasses' },
  { name: 'Sunglasses', value: 'sunglasses' },
];

export const FACE = [
  { name: 'None', value: null },
  { name: 'Beard', value: 'beard' },
  { name: 'Kitty Smile', value: 'kittySmile' },
  { name: 'Mustache', value: 'mustache' },
  { name: 'Neutral', value: 'neutralFace' },
  { name: 'Pumpkin Head', value: 'pumpkinHead' },
  { name: 'Sinister', value: 'sinisterFace' },
];

export const RIGHT_HAND = [
  { name: 'None', value: null },
  { name: 'Book', value: 'book' },
  { name: 'Crystal', value: 'crystal' },
  { name: 'Crystal Ball', value: 'crystalBall' },
  { name: 'Holly', value: 'holly' },
  { name: 'Magic Wand', value: 'magicWand' },
  { name: 'Mug', value: 'mug' },
  { name: 'Rainbow Flag', value: 'rainbowFlag' },
  { name: 'Shield', value: 'shield' },
];

export const LEFT_HAND = [
  { name: 'None', value: null },
  { name: 'Candle', value: 'candle' },
  { name: 'Candy', value: 'candy' },
  { name: 'Dice', value: 'dice' },
  { name: 'Lantern', value: 'lantern' },
  { name: 'Paint Palette', value: 'paint' },
  { name: 'Potion', value: 'potion' },
];

export const BODY = [
  { name: 'None', value: null },
  { name: '1 Shirt', value: '1Shirt' },
  { name: '20 Shirt', value: '20Shirt' },
  { name: 'Bat Shirt', value: 'batShirt' },
  { name: 'Bee Shirt', value: 'beeShirt' },
  { name: 'Cape', value: 'cape' },
  { name: 'Crystal Shirt', value: 'crystalShirt' },
  { name: 'Holiday Sweater', value: 'holidaySweater' },
  { name: 'Paw Shirt', value: 'pawShirt' },
  { name: 'Robe', value: 'robe' },
  { name: 'Skull Shirt', value: 'skullShirt' },
  { name: 'Star Shirt', value: 'starShirt' },
];
